import { Col, Form, Input, Row } from 'antd';
import { useIntl } from 'react-intl';

import AlertArea from './AlertArea';

function AuthorNameAndSurname({ disabled, isEditPage = false }) {
  const { formatMessage } = useIntl();

  const form = Form.useFormInstance();

  const nameAreaDisabled = Form.useWatch('status', form);
  const surnameAreaDisabled = Form.useWatch('status', form);

  const nameFieldDisabled = !isEditPage && (nameAreaDisabled || disabled);
  const surnameFieldDisabled = !isEditPage && (surnameAreaDisabled || disabled);

  return (
    <>
      <Form.Item
        hidden
        name="id"
      >
        <Input />
      </Form.Item>
      <Row
        gutter={24}
        className="gx-flex-row"
      >
        <Col span={12}>
          <Form.Item
            name="name"
            label={formatMessage({ id: 'appModule.name' })}
            className="gx-mb-2"
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'appModule.requiredFieldMessage' }, { field: formatMessage({ id: 'appModule.name' }) }),
              },
            ]}
          >
            <Input disabled={nameFieldDisabled} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="surname"
            label={formatMessage({ id: 'appModule.surname' })}
            className="gx-mb-2"
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'appModule.requiredFieldMessage' }, { field: formatMessage({ id: 'appModule.surname' }) }),
              },
            ]}
          >
            <Input disabled={surnameFieldDisabled} />
          </Form.Item>
        </Col>
      </Row>
      <AlertArea isNewAuthorState />
    </>
  );
}

export default AuthorNameAndSurname;
